// Static data — all products / artists / categories / delivery methods
// embedded directly into the frontend so the app works without a backend.
// You can edit this file to add / remove / change products and they will
// appear immediately on the deployed site.

const now = new Date().toISOString();

export const artists = [
  {
    id: "art-eljan-nagi",
    name: "Eljan Nagi",
    slug: "eljan-nagi",
    bio: "Baku-based deep house producer crafting the sound of the Caspian. Resident of Underground Baku since 2018.",
    image_url: "https://images.unsplash.com/photo-1659150140178-d672b4763fd0?w=1200&q=85",
    featured: true,
    created_at: now,
  },
  {
    id: "art-aphex-twin",
    name: "Aphex Twin",
    slug: "aphex-twin",
    bio: "Richard D. James — pioneer of IDM, ambient, and modern electronic experimentation.",
    image_url: "https://images.unsplash.com/photo-1614741174040-569dc1197092?w=1200&q=85",
    featured: true,
    created_at: now,
  },
  {
    id: "art-miles-davis",
    name: "Miles Davis",
    slug: "miles-davis",
    bio: "The greatest jazz innovator of the 20th century. Kind of Blue redefined modal jazz forever.",
    image_url: "https://images.pexels.com/photos/14351044/pexels-photo-14351044.jpeg?auto=compress&w=1200",
    featured: false,
    created_at: now,
  },
  {
    id: "art-baku-jazz-quartet",
    name: "Baku Jazz Quartet",
    slug: "baku-jazz-quartet",
    bio: "Live at Flame Towers. The new wave of Azerbaijani jazz.",
    image_url: "https://images.unsplash.com/photo-1659150140178-d672b4763fd0?w=1200&q=85",
    featured: false,
    created_at: now,
  },
];

export const categories = [
  {
    id: "cat-electronic",
    name: "Electronic",
    slug: "electronic",
    description: "Beats from beyond — techno, IDM, ambient.",
    image_url: "https://images.unsplash.com/photo-1535905557558-afc4877a26fc?w=1200&q=85",
    created_at: now,
  },
  {
    id: "cat-jazz",
    name: "Jazz",
    slug: "jazz",
    description: "From Blue Note classics to modern fusion.",
    image_url: "https://images.pexels.com/photos/6621666/pexels-photo-6621666.jpeg?auto=compress&w=1200",
    created_at: now,
  },
  {
    id: "cat-azeri-underground",
    name: "Azeri Underground",
    slug: "azeri-underground",
    description: "The sound of Baku — pressed locally.",
    image_url: "https://images.pexels.com/photos/10012882/pexels-photo-10012882.jpeg?auto=compress&w=1200",
    created_at: now,
  },
  {
    id: "cat-ambient",
    name: "Ambient",
    slug: "ambient",
    description: "Drift away — atmospheric and minimal.",
    image_url: "https://images.unsplash.com/photo-1614741174040-569dc1197092?w=1200&q=85",
    created_at: now,
  },
];

export const products = [
  {
    id: "prod-the-underground-ep",
    title: "The Underground EP",
    slug: "the-underground-ep",
    artist_id: "art-eljan-nagi",
    category_id: "cat-electronic",
    price_azn: 38.0,
    cover_url: "https://images.pexels.com/photos/6621666/pexels-photo-6621666.jpeg?auto=compress&w=900&h=900",
    images: [],
    description: "Four-track EP showcasing Baku's bubbling techno underground. Limited 200 copies on translucent red vinyl.",
    catalog_no: "BAKU-009-EP",
    format: "12\" EP",
    rpm: "45 RPM",
    weight: "180g",
    release_date: "JAN 18, 2024",
    tracklist: [
      { title: "Subway A1", duration: "06:15" },
      { title: "Subway A2", duration: "05:48" },
      { title: "Subway B1", duration: "07:02" },
      { title: "Subway B2", duration: "06:30" },
    ],
    spotify_track_id: "",
    spotify_album_id: "",
    stock: 4,
    featured: true,
    limited: true,
    new_arrival: true,
    views: 0,
    sold: 0,
    created_at: "2026-05-01T11:32:49.014788+00:00",
  },
  {
    id: "prod-nocturnal-studies",
    title: "Nocturnal Studies",
    slug: "nocturnal-studies",
    artist_id: "art-aphex-twin",
    category_id: "cat-ambient",
    price_azn: 70.0,
    cover_url: "https://images.unsplash.com/photo-1484755560699-847e30d1deea?w=900&q=85",
    images: [],
    description: "Late-night listening at its finest. Etherial textures and subtle rhythmic pulses across two sides of pristine vinyl.",
    catalog_no: "AMB-NS-104",
    format: "180G VINYL LP",
    rpm: "33 ⅓ RPM",
    weight: "180g",
    release_date: "MAR 04, 2022",
    tracklist: [
      { title: "Drift", duration: "08:11" },
      { title: "Half Light", duration: "09:20" },
      { title: "Resonance Field", duration: "07:45" },
    ],
    spotify_track_id: "",
    spotify_album_id: "",
    stock: 9,
    featured: false,
    limited: false,
    new_arrival: true,
    views: 0,
    sold: 0,
    created_at: "2026-05-01T11:32:49.014783+00:00",
  },
  {
    id: "prod-flame-tower-sessions",
    title: "Flame Tower Sessions",
    slug: "flame-tower-sessions",
    artist_id: "art-baku-jazz-quartet",
    category_id: "cat-jazz",
    price_azn: 55.0,
    cover_url: "https://images.unsplash.com/photo-1614741174040-569dc1197092?w=900&q=85",
    images: [],
    description: "Live recording from atop Baku's iconic Flame Towers. A jazz fusion masterpiece blending traditional Azeri mugham scales with modern improvisation.",
    catalog_no: "BAKU-007-V",
    format: "180G VINYL LP",
    rpm: "33 ⅓ RPM",
    weight: "180g",
    release_date: "MAY 12, 2024",
    tracklist: [
      { title: "Approach", duration: "07:12" },
      { title: "Mugham Suite", duration: "11:45" },
      { title: "Caspian Skyline", duration: "06:22" },
    ],
    spotify_track_id: "",
    spotify_album_id: "",
    stock: 15,
    featured: false,
    limited: false,
    new_arrival: true,
    views: 0,
    sold: 0,
    created_at: "2026-05-01T11:32:49.014779+00:00",
  },
  {
    id: "prod-kind-of-blue",
    title: "Kind of Blue",
    slug: "kind-of-blue",
    artist_id: "art-miles-davis",
    category_id: "cat-jazz",
    price_azn: 95.0,
    cover_url: "https://images.pexels.com/photos/10012882/pexels-photo-10012882.jpeg?auto=compress&w=900",
    images: [],
    description: "The most important jazz album ever recorded. 1959 sessions, modal jazz perfection. Stereo reissue from the original master tapes.",
    catalog_no: "CL-1355",
    format: "180G VINYL LP",
    rpm: "33 ⅓ RPM",
    weight: "180g",
    release_date: "AUG 17, 1959",
    tracklist: [
      { title: "So What", duration: "09:22" },
      { title: "Freddie Freeloader", duration: "09:46" },
      { title: "Blue in Green", duration: "05:37" },
      { title: "All Blues", duration: "11:33" },
      { title: "Flamenco Sketches", duration: "09:26" },
    ],
    spotify_track_id: "7q3kkfAVpmcZ8g6JUThi3o",
    spotify_album_id: "",
    stock: 8,
    featured: true,
    limited: false,
    new_arrival: true,
    views: 0,
    sold: 0,
    created_at: "2026-05-01T11:32:49.014774+00:00",
  },
  {
    id: "prod-selected-ambient-works",
    title: "Selected Ambient Works 85-92",
    slug: "selected-ambient-works-85-92",
    artist_id: "art-aphex-twin",
    category_id: "cat-electronic",
    price_azn: 85.0,
    cover_url: "https://images.unsplash.com/photo-1535905557558-afc4877a26fc?w=900&q=85",
    images: [],
    description: "Richard D. James' seminal debut. A landmark in ambient electronic music, pressed on 180g audiophile vinyl with original Apollo artwork.",
    catalog_no: "AMB-LP3922",
    format: "2LP • 180G",
    rpm: "33 ⅓ RPM",
    weight: "320g",
    release_date: "NOV 09, 1992",
    tracklist: [
      { title: "Xtal", duration: "04:51" },
      { title: "Tha", duration: "09:01" },
      { title: "Pulsewidth", duration: "03:48" },
      { title: "Ageispolis", duration: "05:20" },
    ],
    spotify_track_id: "5U1tMecqLfOkPDIUK9SVKa",
    spotify_album_id: "",
    stock: 6,
    featured: true,
    limited: true,
    new_arrival: false,
    views: 0,
    sold: 0,
    created_at: "2026-05-01T11:32:49.014770+00:00",
  },
  {
    id: "prod-azeri-deep-house",
    title: "Azeri Deep House Vol. 1",
    slug: "azeri-deep-house-vol-1",
    artist_id: "art-eljan-nagi",
    category_id: "cat-azeri-underground",
    price_azn: 45.0,
    cover_url: "https://images.pexels.com/photos/6621666/pexels-photo-6621666.jpeg?auto=compress&w=900",
    images: [],
    description: "A definitive collection of contemporary deep house from the heart of Baku. Mastering performed at Abbey Road Studios for maximum sonic fidelity on analog systems.",
    catalog_no: "BAKU-001-V",
    format: "180G VINYL LP",
    rpm: "33 ⅓ RPM",
    weight: "450g",
    release_date: "OCT 24, 2023",
    tracklist: [
      { title: "Wind of Absheron", duration: "06:42" },
      { title: "Caspian Nightfall", duration: "05:15" },
      { title: "Old City Rituals", duration: "07:01" },
      { title: "Flame Tower Dub", duration: "06:08" },
    ],
    spotify_track_id: "4uLU6hMCjMI75M1A2tKUQC",
    spotify_album_id: "",
    stock: 12,
    featured: true,
    limited: true,
    new_arrival: true,
    views: 0,
    sold: 0,
    created_at: "2026-05-01T11:32:49.014765+00:00",
  },
];

export const deliveryMethods = [
  {
    id: "del-standard",
    name: "Standard",
    code: "standard",
    description: "3-5 days delivery to your door",
    price_azn: 15.0,
    duration: "3-5 DAYS",
    icon: "truck",
    active: true,
  },
  {
    id: "del-express",
    name: "Express",
    code: "express",
    description: "Next day express courier",
    price_azn: 40.0,
    duration: "24 HOURS",
    icon: "zap",
    active: true,
  },
  {
    id: "del-pickup",
    name: "Branch Pickup",
    code: "pickup",
    description: "Pick up from our Baku store",
    price_azn: 0.0,
    duration: "INSTANT",
    icon: "store",
    active: true,
  },
  {
    id: "del-post",
    name: "Post",
    code: "post",
    description: "Azerbaijan Post nationwide",
    price_azn: 8.0,
    duration: "5-10 DAYS",
    icon: "mail",
    active: true,
  },
];

export const currencyRates = { AZN: 1, USD: 0.59, EUR: 0.54 };
